import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { HttpClient,  HttpHeaders} from '@angular/common/http';
import { environment } from '@env/environment';
import { Encrypt } from '../../utils/encrypt/encrypt';


let options;

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private api: ApiService, private http: HttpClient, private utilsService: Encrypt) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  sendContactInfo(name: string, email: string, message: string, bcc: any, token: string|undefined, sendFrom: string) {
    name = this.utilsService.cryptDataIV(name);
    email = this.utilsService.cryptDataIV(email);
    message = this.utilsService.cryptDataIV(message);
    bcc = this.utilsService.cryptDataIV(bcc);
    sendFrom = this.utilsService.cryptDataIV(sendFrom);
    
    let isHome = this.utilsService.cryptDataIV(true);
    return this.api.post('api/contact', { name: name, email: email, message: message, bcc: bcc, isHome: isHome, token: token, sendFrom: sendFrom }).pipe(
      map(response => {
        return response;
      })
    );
  }

  getTimeToken() {
    return this.http.get(environment.apiUrlEmail + '/api/time-token');
  }
  
}
